<template>
  <v-container
    id="container"
    grid-list-md
    text-xs-center
  >
    <v-row>
      <ConversationsList v-if="isUser" />
      <v-col :class="[isUser ? 'admin' : 'stakeholder']">
        <router-view :key="$route.fullPath" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConversationsList from "@/components/Conversation/ConversationsList";

export default {
  name: "Conversation",
  components: {
    ConversationsList
  },
  data() {
    return {
      isUser: localStorage.getItem("TOKEN_STORAGE_KEY")
    };
  }
};
</script>

<style scoped>
#container {
  margin: 0%;
  margin-left: 0%;
  max-width: 100%;
}
.admin {
  margin-left: 0%;
  height: 80vh !important;
}
.stakeholder {
  margin-left: 0%;
}
</style>
